<template>
  <div class="logout-modal-mask">
      <div class="logout-modal-wrapper">
        <div class="logout-modal-container">

          <div class="logout-modal-header">
            <div>
              <i class="icon ico-logout"></i>
            </div>
          </div>

          <div class="logout-modal-body">
            <h3>¿Estás seguro que deseas salir?</h3>
          </div>

          <div class="logout-modal-footer">
            <slot name="footer">
              <button class="btn btn-ghost" @click="hideModal()">
                No
              </button>
              <button class="btn btn-primary" @click="logout()">
                Sí
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: 'logout-modal',
  methods: {
    hideModal: function(){
      this.changeModal(false)
    },
    logout: function(){
      this.userLogout();
      this.changeModal(false);
      this.$router.push({path: "/"})
    },
    ...mapActions('auth', [
        'userLogout',
        'changeModal'
    ])
  }
}
</script>

<style lang="sass">
.logout-modal-mask
  font-family: Montserrat
  position: fixed
  z-index: 99998
  top: 0
  left: 0
  width: 100%
  height: 100%
  background-color: rgba(0, 0, 0, .5)
  display: table
  transition: opacity .3s ease
  text-align:center
.logout-modal-wrapper
  display: table-cell
  vertical-align: middle
.logout-modal-container
  max-width: 464px
  border-radius: 8px
  box-shadow: 0 2px 10px 0 rgba(173, 182, 212, 0.45)
  background-color: #ffffff
  margin: 0 auto
  padding: 24px 12px
  transition: all .3s ease
  @media (max-width: $tablet)
    max-width: calc(100% - 40px)
    margin: 0 8px
.logout-modal-header
  text-align: center
.logout-modal-header i
  color: #c90b2f
  font-size: 72px
.logout-modal-body 
  text-align: center
  margin: 20px 0
.logout-modal-body h3
  font-size: 24px
  font-weight: 500
.logout-modal-footer
  text-align: center
.logout-modal-footer .btn
  padding: 15px 0
  @media (max-width: $tablet)
    margin: 8px auto 0
    width: 80%
    padding: 12px 0
.logout-modal-footer .btn:first-of-type
  margin-right: 40px
  @media (max-width: $tablet)
    margin-right: 0
/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */
.modal-enter
  opacity: 0
.modal-leave-active
  opacity: 0
.modal-enter .logout-modal-container,
.modal-leave-active .logout-modal-container
  -webkit-transform: scale(1.1)
  transform: scale(1.1)
</style>


